<template>
    <app-page>
	    <content-container class="p-1">
		    <h2 class="page-title">Your account</h2>

		    <card title="Profile">
			
			    <list>
				    <list-item primary-icon="account_circle">
					    <p>Name</p>
					    <h1>Dr. John Hammond</h1>
				    </list-item>
				    <list-item primary-icon="fingerprint">
					    <p>Username</p>
					    <h1>johnhammond</h1>
				    </list-item>
				    <list-item primary-icon="email">
					    <p>Email</p>
					    <h1>jhammond@joshspharmacy.com</h1>
				    </list-item>
			    </list>
			
		    </card>

		    <div class="row">
			    <div class="col">
				    <card title="Your groups">
					
					    <list>
						    <list-item primary-icon="group_work" title="PioneerRx Ecosystem" subtitle="Member" />
					    </list>

					    <div class="card-help-footer">
						    <div class="object">
							    <icon src="help_outline" />
						    </div>
						    <div class="body">
							    You can join or leave groups from your PioneerRx pharmacy software.
						    </div>
					    </div>

				    </card>
			    </div>

			    <div class="col">
				    <card title="Your pharmacies">
			
					    <list>
						    <list-item primary-icon="local_pharmacy" title="Josh's Pharmacy #1" subtitle="Administrator" />
						    <list-item primary-icon="local_pharmacy" title="Josh's Pharmacy #2" subtitle="User" />
						    <list-item primary-icon="local_pharmacy" title="Josh's Pharmacy #3" subtitle="User" />
					    </list>

					    <div class="card-help-footer">
						    <div class="object">
							    <icon src="help_outline" />
						    </div>
						    <div class="body">
							    You can manage your pharmacies from your PioneerRx pharmacy software.
						    </div>
					    </div>

				    </card>
			    </div>
		    </div>


	    </content-container>
    </app-page>
</template>


<script>
	export default {
	};
</script>


<style lang="scss" scoped>
@import '~@/assets/styles/references';

.card-help-footer { margin: gx(0.5); padding: 0; border: 1px solid color(black, divider); background-color: color(gray, 100); font-size: $font-size-xs; color: color(black, secondary); display: flex; flex-direction: row; align-items: center; border-radius: $border-radius;
	.object, .body { border: gx(0.5) solid transparent; }
	.object { flex: 0 0 auto; display: flex; color: color(black, hint); }
	.body { flex: 1 1 auto; }
 }

@include media-breakpoint-up(md) {
	.container { max-width: 600px; }
}
</style>
